var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"single-value"},[_c('p',{style:({
      fontSize: _vm.configs.parameters['Text size'],
      fontStyle:
        _vm.configs.parameters['Text weight'] === 'italic' || _vm.configs.parameters['Text weight'] === 'bold-italic'
          ? 'italic'
          : 'normal',
      fontWeight:
        _vm.configs.parameters['Text weight'] === 'bold' || _vm.configs.parameters['Text weight'] === 'bold-italic'
          ? 'bold'
          : 'normal'
    }),domProps:{"innerHTML":_vm._s(_vm.items)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }